import { DYNAMIC_INVOICE_ID_TYPES } from '@weft/api-definition';
import { isNullOrUndefined, validateNotEmptyString } from '@weft/utils';
import React from 'react';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { useContractsByCustomerId } from '../../../hooks/requests/use-contracts-by-customer-id';
import { useDynamicInvoice } from '../../../hooks/requests/use-dynamic-invoice';
import { useParamsDynamicInvoiceIdOrDefault } from '../../../hooks/use-dynamic-invoice-id';
import { DynamicInvoiceViewPage } from '../../invoices/DynamicInvoiceViewPage';
import { DynamicInvoiceContextProvider } from '../../invoices/DynamicInvoiceViewPage/dynamic-invoice-context';
import { DynamicInvoiceFallbackComponent } from '../../invoices/DynamicInvoiceViewPage/DynamicInvoiceFallbackComponent';

const CustomerRealTimeActivityPage: React.FC = () => {
  const customerId = useParamsDynamicInvoiceIdOrDefault(undefined);
  validateNotEmptyString(customerId, 'customerId');

  const { data: contractsResponse } = useContractsByCustomerId(customerId);

  const { data: dynamicInvoiceDataResponse } = useDynamicInvoice(customerId, DYNAMIC_INVOICE_ID_TYPES.Customer, {
    enabled: contractsResponse.countedFilteredContracts > 0,
  });

  if (isNullOrUndefined(dynamicInvoiceDataResponse)) {
    return <DynamicInvoiceFallbackComponent />;
  }

  return (
    <DynamicInvoiceContextProvider dynamicInvoiceDataResponse={dynamicInvoiceDataResponse}>
      <DynamicInvoiceViewPage
        idType={DYNAMIC_INVOICE_ID_TYPES.Customer}
        doNotUsePageLayout
      />
    </DynamicInvoiceContextProvider>
  );
};

const CustomerRealTimeActivityPageWithSuspenseBoundary = withSuspenseBoundary(CustomerRealTimeActivityPage, { errorBoundaryProps: { fallback: () => <DynamicInvoiceFallbackComponent/> } });

export { CustomerRealTimeActivityPageWithSuspenseBoundary as CustomerRealTimeActivityPage };